import { DEFAULT_PREFIX_PHONE, IS_AUTOCOMPLETE_ENABLED } from '@/constants';
import type { AddressFormValues } from '@/sections/address/types/AddressFormValues';

export const FORM_DEFAULT_VAUES: AddressFormValues = {
  region: 0,
  commune: '',
  streetName: '',
  streetNumber: '',
  additionalStreetInfo: '',
  alias: '',
  additionalAddressInfo: '',
  firstName: '',
  lastName: '',
  phone: '',
  isDefault: false,
  'no-number': false,
  'prefix-phone': DEFAULT_PREFIX_PHONE,
  'save-address': true,
  isAutocomplete: IS_AUTOCOMPLETE_ENABLED,
  latitude: undefined,
  longitude: undefined
};
